<template>
  <SelectSingleInput
    v-model="model"
    :items="items"
    item-text="defectText"
    item-value="defectCd"
    :label="labelComputed"
    :exceptCdList="exceptCdList"
    :exceptComparator="exceptComparator"
    :disabled="disabled"
    :loading="loading"
    :required="required"
  />
</template>

<script>
import SelectSingleInput from '@/components/atoms/base/select/SelectSingleInput'
import { API } from '@/plugins/api'
import APIUtils from '@/mixin/api-utils.js'
import Message from '@/mixin/message-utils.js'

export default {
  name: 'PartDefectInput',

  mixins: [APIUtils, Message],

  components: {
    SelectSingleInput,
  },

  props: {
    value: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false,
    },
    required: {
      type: Boolean,
      default: false,
      required: false,
    },
    partCd: {
      type: String,
      required: true,
    },
    partRev: {
      type: Number,
      required: true,
    },
    validOnly: {
      type: Boolean,
      required: false,
      default: false,
    },
    label: {
      type: String,
      required: false,
      default: '',
    },
    exceptCdList: {
      type: Array,
      required: false,
      default: () => [],
    },
  },

  data() {
    return {
      items: [],
      loading: false,
    }
  },

  computed: {
    model: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value ? value : '')
      },
    },
    labelComputed: {
      get() {
        return this.label
      },
    },
  },

  methods: {
    exceptComparator(item, except) {
      return item.defectCd == except.defectCd && item.defectCd != this.model
    },
  },

  async mounted() {
    this.loading = true
    try {
      const params = {
        partCd: this.partCd,
        partRev: this.partRev,
      }
      if (this.validOnly) {
        params.validOnly = true
      }

      const elements = await API.get('/master/part/defects', params)

      elements.forEach((item) => {
        item['defectText'] = `${item['defectCd']} : ${item['defectName']}`
        this.items.push(item)
      })
    } catch (error) {
      this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0002', { p0: this.$t('ELE0011') })))
    } finally {
      this.loading = false
    }
  },
}
</script>
